import React from "react";
import { Table } from "react-bootstrap";
import { fetchPublicBlogsAdmin, deletePublicBlog } from "../../actions/publicBlogActions";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { localAPI } from "../../api/local";
import { Redirect } from "react-router-dom";
import AdminPublicBlogEntry from "./AdminPublicBlogEntry";
import { Helmet } from "react-helmet";


export class AdminPublicBlogPage extends React.Component {
  async componentDidMount() {
    await this.props.fetchPublicBlogsAdmin();
    await localAPI
      .get("/api/users/isadmin")
      .then((data) => {
        if (!data.data.success) this.setState({ isAdmin: false });
      })
      .catch((err) => {
        this.setState({ isAdmin: false });
      });
  }

  state = {
    deleteModalShow: false,
    editAddModalShow: false,
    editModalShow: false,
    publicBlogToDelete: {},
    isAdmin: true,
    publicBlogToEdit: {},
  };

  handleDeleteModalClose = () => {
    this.setState({ deleteModalShow: false, publicBlogToDelete: {} });
  };
  handleDeleteModalShow = (publicBlog) =>
    this.setState({ deleteModalShow: true, publicBlogToDelete: publicBlog });
  handleEditAddModalClose = () => {
    this.setState({ editAddModalShow: false });
  };
  handleEditAddModalShow = (publicBlog) =>
    this.setState({ editAddModalShow: true, publicBlogToEdit: publicBlog });

  renderTable = () => {
    return this.props.publicBlogs.map((publicBlog, key) => {
      return (
        <tr
          key={key + 1}
          style={
            publicBlog.hideBlog ? { background: "rgba(128, 128, 128, 0.2)" } : {}
          }
        >
          <td>{key + 1}</td>
          <td>
            <img
              style={{ maxWidth: "100px" }}
              src={publicBlog.thumbnailLink}
              alt={`thumbnail for ${publicBlog.title}`}
              width="1200"
              height="700"
            />
          </td>
          <td>{publicBlog._id}</td>
          <td>{publicBlog.title}</td>
          <td>som link</td>
          <td>{publicBlog.category}</td>
          <td>
            {new Date(publicBlog.uploadDateTime).toLocaleString("hi-IN", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </td>
          <td>
            <div
              className="btn btn-warning"
              onClick={() => this.handleEditAddModalShow(publicBlog)}
            >
              Edit
            </div>
            <div
              className="btn btn-danger"
              onClick={() => this.handleDeleteModalShow(publicBlog)}
            >
              Delete
            </div>
          </td>
        </tr>
      );
    });
  };

  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {this.state.isAdmin ? (
          <div>
            <Modal
              show={this.state.deleteModalShow}
              onHide={this.handleDeleteModalClose}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Public Blog?</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <p>Do you want to delete this public blog?</p>
                <Table>
                  <thead>
                    <tr>
                      <th>Thumbnail</th>
                      <th>id</th>
                      <th>Title</th>
                      <th>Upload Date</th>
                    </tr>
                    <tr>
                      <td>
                        {
                          <img
                            alt={`thumbnail for ${this.state.publicBlogToDelete.title}`}
                            src={this.state.publicBlogToDelete.thumbnailLink}
                            style={{ maxWidth: "100px" }}
                            width="1200"
                            height="700"
                          />
                        }
                      </td>
                      <td>{this.state.publicBlogToDelete._id}</td>
                      <td>{this.state.publicBlogToDelete.title}</td>
                      <td>
                        {new Date(
                          this.state.publicBlogToDelete.uploadDateTime
                        ).toLocaleString("hi-IN", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })}
                      </td>
                    </tr>
                  </thead>
                </Table>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary">No</Button>
                <Button
                  variant="danger"
                  onClick={async () =>
                    await this.props.deletePublicBlog(this.state.publicBlogToDelete._id)
                  }
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.editAddModalShow}
              onHide={this.handleEditAddModalClose}
              fullscreen={true}
            >
              <Modal.Header closeButton>
                <Modal.Title>Add Public Blog</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <AdminPublicBlogEntry publicBlogToEdit={this.state.publicBlogToEdit} />
              </Modal.Body>
            </Modal>

            <button
              className="btn btn-primary"
              onClick={() => this.handleEditAddModalShow()}
            >
              Add PublicBlog
            </button>

            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Thumbnail</th>
                  <th>id</th>
                  <th>Title</th>
                  <th>VideoLink</th>
                  <th>Category</th>
                  <th>Upload Date</th>
                  <th>Options</th>
                </tr>
                {this.props.publicBlogs ? this.renderTable() : "loading"}
              </thead>
            </Table>
          </div>
        ) : (
          <Redirect to="/" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    publicBlogs: state.publicBlogs.publicBlogs?.publicBlogs,
    error: state.publicBlogs.error,
  };
};

export default connect(mapStateToProps, { fetchPublicBlogsAdmin, deletePublicBlog })(
  AdminPublicBlogPage
);
